import { render, staticRenderFns } from "./ReturnWithBranch.vue?vue&type=template&id=609fb2ac&scoped=true&"
import script from "./ReturnWithBranch.vue?vue&type=script&lang=js&"
export * from "./ReturnWithBranch.vue?vue&type=script&lang=js&"
import style0 from "./ReturnWithBranch.vue?vue&type=style&index=0&id=609fb2ac&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "609fb2ac",
  null
  
)

export default component.exports